<div
  class="d-flex flex-column h-100"
  caLocalizationScope="navigation"
  data-automation-id="authorize-impersonation-readonly-container"
>
  <div class="flex-grow-1">
    <div class="mb-3">
      <h4 class="heading-20 mb-2 mb-sm-4" data-automation-id="impersonation-details-label">
        {{ 'impersonationDetails' | caLocalize }}
      </h4>
    </div>
    <div class="row mb-2" data-automation-id="window-period-label">
      <div class="col-12 col-sm-5 text-muted">{{ 'windowPeriod' | caLocalize }}:</div>
      <div class="col-12 col-sm-7" data-automation-id="window-period-value">
        {{
          getDurationKeyFromValue(authorizeImpersonation.accessDurationDays)
            | caImpersonationDurationLocalizationKey
            | caLocalize
        }}
      </div>
    </div>
    <div class="row mb-2" data-automation-id="access-expiration">
      <div class="col-12 col-sm-5 text-muted">{{ 'accessExpiration' | caLocalize }}:</div>
      <div class="col-12 col-sm-7" data-automation-id="access-expiration-value">
        {{ authorizeImpersonation.accessExpiresDateTime | caDate }},
        {{ authorizeImpersonation.accessExpiresDateTime | caTime : { ignoreTimeZoneLabel: true } }}
      </div>
    </div>
    <div class="row mb-2" data-automation-id="access-scope">
      <div class="col-12 col-sm-5 text-muted">{{ 'accessTo' | caLocalize }}:</div>
      <div class="col-12 col-sm-7" data-automation-id="access-to-value">{{ authorizeImpersonation.accessScope }}</div>
    </div>
    <div class="row mb-2" data-automation-id="notes">
      <div class="col-12 col-sm-5 text-muted">{{ 'notesLabel' | caLocalize }}:</div>
      <div class="col-12 col-sm-7 text-break" data-automation-id="notes-value">
        {{ authorizeImpersonation.notes ? authorizeImpersonation.notes : 'N/A' }}
      </div>
    </div>
  </div>

  <span class="text-muted body-50" data-automation-id="reauthorize-msg">
    {{ 'reauthorizeAccessMsg' | caLocalize }}
  </span>
</div>
